import m from "../../geodata/es2015/lithuaniaLow";
window.am4geodata_lithuaniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/lithuaniaLow.js
// module id = null
// module chunks = 